import { computed, watch, ref, ssrRef, useContext, onMounted } from '@nuxtjs/composition-api';
import { isEmpty, merge } from 'lodash';
import { GTM_ID } from '~/constants/config';
import { useAuth } from '~/modules/auth/state/useAuth';

const tagManagerLoaded = ssrRef(false);
export const loadGoogleTagManager = () => {
  const context = useContext();
  const head = context.app.head();
  head.noscript = head.noscript || [];
  head.__dangerouslyDisableSanitizersByTagID = head.__dangerouslyDisableSanitizersByTagID || {};
  head.script.push({
    hid: 'tagmanager',
    innerHTML: `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${GTM_ID}');
    `,
  });
  head.noscript.push({
    hid: 'gtm-noscript',
    innerHTML: `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
    body: true,
  });
  head.__dangerouslyDisableSanitizersByTagID.tagmanager = ['innerHTML'];
  head.__dangerouslyDisableSanitizersByTagID['gtm-noscript'] = ['innerHTML'];
  tagManagerLoaded.value = true;
};

const watchEventObject = (eventObject, dependencyArray, callback) => {
  const init = eventObject instanceof Function ? computed(eventObject) : ref(eventObject);
  watch(
    init,
    (value) => {
      if (dependencyArray.some((dependency) => isEmpty(dependency.value))) return;
      if (process.client && tagManagerLoaded.value) {
        callback(value);
      }
    },
    { immediate: true }
  );
};

export const sendPageviewEvent = (eventObject, dependencyArray = [], loggedIn) => {
  const loginRef = ref(false);
  if (loggedIn === undefined) {
    const { isLoggedIn } = useAuth();
    loginRef.value = isLoggedIn.value;
  } else {
    loginRef.value = loggedIn;
  }

  const init = eventObject instanceof Function ? computed(eventObject) : ref(eventObject);

  const sendEvent = (init) => {
    const pageViewEvent = {
      event: 'PageView', // Sabit olarak bu değer gelmelidir.
      page: {
        name: document.title, // Sayfanın adı gelmelidir. H1 kullanılabilir
      },
      user: {
        isLoggedIn: loginRef.value,
      },
    };
    window.dataLayer.push(merge(pageViewEvent, init.value));
  };

  if (init.value?.event === 'vPageView') {
    sendEvent(init);
  } else {
    onMounted(() => {
      sendEvent(init);
    });
  }
};

export const sendArticleRefTags = (eventObject, dependencyArray = []) => {
  watchEventObject(eventObject, dependencyArray, (refTags) => {
    if (refTags) {
      refTags.forEach((refTag) => {
        window.dataLayer.push({
          event: 'tag_impression', // Sabit olarak bu değer yazılmalıdır.
          tag_name: refTag.name,
          tag_value: 1, // Sabit olarak bu değer yazılmalıdır.
        });
      });
    }
  });
};

export const sendArticleHashtags = (eventObject, dependencyArray = []) => {
  watchEventObject(eventObject, dependencyArray, (hashtags) => {
    if (hashtags) {
      hashtags.forEach((hashtag) => {
        window.dataLayer.push({
          event: 'hashtag_impression', // Sabit olarak bu değer yazılmalıdır.
          hashtag_name: hashtag.name,
          hashtag_value: 1, // Sabit olarak bu değer yazılmalıdır.
        });
      });
    }
  });
};
